import type { Box, BoxWithLabel } from '@/type';

import usePcdRenderingStore from '../pcdRenderingStore';
import type { LabelingBoxStoreState } from './type';

export const changeAllBoxProps = <P extends keyof Omit<BoxWithLabel, 'id'>>(
  {
    boxUpdateMap,
    pcdIndexBoxListMap,
  }: {
    boxUpdateMap: {
      [x: Box['id']]: {
        [K in P]?: Omit<BoxWithLabel, 'id'>[P];
      };
    };
    pcdIndexBoxListMap: LabelingBoxStoreState['pcdIndexBoxListMap'];
  },
  callback: (
    pcdIndexBoxListMap: LabelingBoxStoreState['pcdIndexBoxListMap'],
    lastModifiedBoxList: BoxWithLabel[],
  ) => void,
) => {
  const pcdIndex = getCurrentPcdIndex();
  const lastModifiedBoxList: BoxWithLabel[] = [];
  let boxList = getBoxList({ pcdIndexBoxListMap });

  Object.entries(boxUpdateMap).forEach(([id, propValMap]) => {
    boxList = boxList.map(box => {
      if (box.id !== id) return box;

      const toModifyBox = {
        ...box,
        ...propValMap,
        confidence: 1, // changeAllBoxProps 호출은 user 액션에 의한 호출이므로 confidence 를 1로 고정해주어야 함
      };

      lastModifiedBoxList.push(toModifyBox);

      return toModifyBox;
    });
  });

  callback(
    {
      ...pcdIndexBoxListMap,
      [pcdIndex]: boxList,
    },
    lastModifiedBoxList,
  );
};

export const getBoxList = ({
  pcdIndexBoxListMap,
  pcdIndex = getCurrentPcdIndex(),
}: {
  pcdIndexBoxListMap: LabelingBoxStoreState['pcdIndexBoxListMap'];
  pcdIndex?: number;
}) => {
  const boxList = pcdIndexBoxListMap[pcdIndex];

  return boxList ?? [];
};

export const getCurrentPcdIndex = () =>
  usePcdRenderingStore.getState().pcdIndex;
